import { gql } from "@apollo/client";

export const CREATE_MEMBERSHIP_DURATION = gql`
  mutation CreateMembershipDuration($input: CreateMembershipDurationInput!) {
    createMembershipDuration(input: $input) {
           data {
            membership_duration {
                created_at
                description
                duration_type
                id
                number_of_days
                package_id
                price
                updated_at
                price_usd
                package {
                    created_at
                    description
                    id
                    name
                    package_type
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;

export const UPDATE_MEMBERSHIP_DURATION = gql`
  mutation UpdateMembershipDuration($input: UpdateMembershipDurationInput!) {
    updateMembershipDuration(input: $input) {
           data {
            membership_duration {
                created_at
                description
                duration_type
                id
                number_of_days
                package_id
                price
                updated_at
                price_usd
                package {
                    created_at
                    description
                    id
                    name
                    package_type
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}


`;
export const DELETE_MEMBERSHIP_DURATION = gql`
  mutation DeleteMembershipDuration($duration_id: UUID!) {
    deleteMembershipDuration(duration_id: $duration_id) {
      data {
        message
      }
      error {
        field
        message
        code
      }
    }
  }
`;
